import React, { useState } from "react";
import { ActionIcon, Indicator } from "@mantine/core";
import { BellIcon } from "@phosphor-icons/react";
import { useNotificationContext } from "./notification-context";
import NotificationPanel from "./notification-panel";

interface NotificationBellProps {
  size?: number;
  variant?: "subtle" | "light" | "filled" | "outline" | "default" | "transparent";
  color?: string;
  style?: React.CSSProperties;
}

const NotificationBell: React.FC<NotificationBellProps> = ({
  size = 24,
  variant = "subtle",
  color,
  style,
}) => {
  const [notificationPanelOpen, setNotificationPanelOpen] = useState(false);
  const { unreadCount } = useNotificationContext();

  return (
    <>
      {unreadCount > 0 ? (
        <Indicator inline label={unreadCount} size={16} color="red">
          <ActionIcon
            variant={variant}
            size="md"
            color={color}
            onClick={() => setNotificationPanelOpen(true)}
            style={style}
          >
            <BellIcon size={size} />
          </ActionIcon>
        </Indicator>
      ) : (
        <ActionIcon
          variant={variant}
          size="lg"
          color={color}
          onClick={() => setNotificationPanelOpen(true)}
          style={style}
        >
          <BellIcon size={size} />
        </ActionIcon>
      )}

      <NotificationPanel
        isOpen={notificationPanelOpen}
        onClose={() => setNotificationPanelOpen(false)}
      />
    </>
  );
};

export default NotificationBell;
